<template>
  <!-- eslint-disable -->
  <div>
    <GmapMap
      :center="center"
      :zoom="defaultZoom"
      zoomControl
      ref="gmap"
      :options="{
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
                disableDefaultUi: false,
                gestureHandling: 'cooperative'
              }"
      style="width: 100%; height: 500px; margin-top: 10px"
    >
      <InfoContentGmap
        :infoWinOpen="infoWinOpen"
        :infoWindowPos="infoWindowPos"
        :infoContent="infoContent"
        :bgcolor="infoContent.type === 'EDU' ? '#45bcf3' : '#f3bb45'"
        :title="infoContent.type === 'TRG' ? 'Informações do Evento' : 'Informações da Palestra'"
        @close="infoWinOpen = false"
      />
      <Gmap-Marker
        v-for="(marker, i) in eventsSpecifications"
        :key="i"
        :position="marker.gps"
        :clickable="true"
        :icon="getPinUrl(marker)"
        @click="toggleInfoWindow(marker,marker._id, setContentTRG)"
      ></Gmap-Marker>
      <Gmap-Marker
        v-for="(marker) in eduMarkerCoodinates"
        :key="marker._id"
        :position="marker.gps"
        :clickable="true"
        :icon="imageEdu"
        @click="toggleInfoWindow(marker,marker._id, setContentEDU)"
      ></Gmap-Marker>
    </GmapMap>
    <!--  <vue-gallery-slideshow :images="infoContent.images" :index="index" @close="index = null"></vue-gallery-slideshow>-->

  </div>
</template>

<script>
  import InfoContentGmap from './Trg/Dashboard/InfoContentGmap'
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'google-map',
    props: ['trgMarkerCoordinates', 'eduMarkerCoodinates', 'tags', 'eventsSpecifications'],
    components: {
      InfoContentGmap
    },
    data: function () {
      return {
        showModal: false,
        modalSrc: '',
        mapName: this.name + '-map',
        center: {
          lat: -3.779033,
          lng: -38.512383
        },
        defaultZoom: 8,
        listMarks: [],
        infoContent: {content: {}, type: ''},
        infoWindowPos: null,
        infoWinOpen: false,
        currentMidx: null,
        index: null,
        imageEdu: '/static/img/educacional.png',
        imageTRG: '/static/img/troca_geladeira.png'
      }
    },
    computed: {
      ...mapGetters('project', ['project']),
      ...mapGetters('eventsSpecifications', ['imagesMap'])
    },
    watch: {
      eduMarkerCoodinates: function () {
        this.getLocationState()
      },
      eventsSpecifications: function () {
        this.getLocationState()
      }
    },
    mounted () {
      this.getLocationState()
    },
    methods: {
      ...mapActions('events', ['getURLPhotosEvent', 'countByKeyView', 'countByViewBetween']),
      async toggleInfoWindow (marker, idx, setContent) {
        this.infoWindowPos = marker.gps
        this.infoContent = await setContent(marker)
        // check if its the same marker that was selected if yes toggle
        if (this.currentMidx === idx) {
          this.infoWinOpen = !this.infoWinOpen
        } else {
          this.infoWinOpen = true
          this.currentMidx = idx
        }
      },

      async setContentTRG (marker) {
        const event = this.trgMarkerCoordinates.find(item => item._id === marker.eventId)
        const lampsCount = await this.countByKeyView({
          key: event._id,
          view: 'count-lamps-by-event',
          ddoc: 'count-lamps-by-event'
        })
        const participantsCount = await this.countByViewBetween({
          start_key: [event._id],
          end_key: [event._id, {}],
          ddoc: 'count-participants-event',
          view: 'count-participants-event'
        })

        const photos = await this.getURLPhotosEvent({_id: event._id})
        return {
          content: {
            'Referência': event.reference,
            'Local': event.place,
            'Cidade': event.city,
            'Quantidade de Participantes': participantsCount,
            'Quantidade Geladeiras Entregues': event.numberOfRefigerators,
            'Quantidade de Lâmpadas Trocadas': lampsCount,
            'Data Início': this.$moment(event.startDate).format('LLL'), //this.$moment(new Date()).format('DD-MM-YYYY_HH-mm-ss')
            'Data Fim': this.$moment(event.endDate).format('LLL'),
            'Data Cerimônia': this.$moment(event.dateTimeCeremony).format('LLL'),
            'Data da Entrega da Geladeira': this.$moment(event.dateTimeDelivery).format('LLL') + ' - ' + event.timeEndDelivery,
            'Latitude': marker.gps.lat,
            'Longitude': marker.gps.lng
          },
          images: photos,
          type: 'TRG'
        }
      },
      setContentEDU (marker) {
        const event = this.trgMarkerCoordinates.find(item => item._id === marker.eventId)
        return {
          content: {
            Local: event.place,
            Cidade: event.city
          },
          type: 'EDU'
        }
      },

      setCenter () {
        if (!this.trgMarkerCoordinates || !this.eduMarkerCoodinates) {
          return
        }
        if (this.trgMarkerCoordinates.length !== 0 && this.eduMarkerCoodinates.length !== 0) {
          this.$refs.gmap.$mapPromise.then((map) => {
            const bounds = new google.maps.LatLngBounds()
            for (let i = 0; i < this.trgMarkerCoordinates.length; i++) {
              if (this.trgMarkerCoordinates[i].hasOwnProperty('gps')) {
                bounds.extend(this.trgMarkerCoordinates[i].gps)
              }
            }
            for (let i = 0; i < this.eduMarkerCoodinates.length; i++) {
              if (this.eduMarkerCoodinates[i].hasOwnProperty('gps')) {
                bounds.extend(this.eduMarkerCoodinates[i].gps)
              }
            }
            map.fitBounds(bounds)
          })
        }
      },
      getPinUrl (tag) {
        if (tag.hasOwnProperty('refrigeratorIcon') && tag.refrigeratorIcon !== '') {
          return this.imagesMap.basePath + tag.refrigeratorIcon
        }
        return this.imagesMap.basePath + 'troca_geladeira_0.png'
      },
      waitToCall () {
        setTimeout(() => {
          this.getLocationState()
        }, 1000)
      },
      getLocationState () {
        if (typeof window.google === 'undefined') {
          return this.waitToCall()
        }
        const geocoder = new window.google.maps.Geocoder()
        return geocoder.geocode({'address': `${this.project.state}, Brasil`}, (result, status) => {
          if (status === 'OK') {
            this.center = {
              lat: result[0].geometry.location.lat(),
              lng: result[0].geometry.location.lng()
            }
            // this.gps = this.marker
          }
        }, (err) => console.log('err, geocode', err))
      },
      getHexColor (tag) {
        if (!tag || !tag.hasOwnProperty('tags')) {
          return 'F56C6C'
        }

        let currentTag = this.tags.find(element => {
          return element._id === tag.tags[0]
        })

        if (!currentTag) {
          return 'F56C6C'
        }

        switch (currentTag.color) {
          case 'Success':
            return '67C23A'
          case 'Warning':
            return 'E6A23C'
          case 'Danger':
            return 'F56C6C'
          case 'Info':
            return '909399'
          case 'Primary':
            return '409EFF'
          default:
            return 'F56C6C'
        }
      }
    }
  }
</script>

<style scoped>
  .google-map {
    width: 100%;
    height: 600px;
    margin: 0 auto;
    background: gray;
    border-radius: 8px;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  }

  .image {
    max-width: 200px;
    padding: 5px;
    border-radius: 10px;
    cursor: pointer;
  }

  .d-flex {
    display: flex;
  }

  .d-flex td:first-child {
    padding-right: 1rem;
  }

  .flex-wrap {
    flex-wrap: wrap;
  }

  .justify-content-around {
    justify-content: center
  }

  .justify-content {
    justify-content: flex-start;
  }

  .myContent {
    padding: 12px 100px;
    border-radius: 8px;
    margin-bottom: 16px;
    text-align: center;
  }

  .myContent.trg {
    background: #f3bb45;
  }

  .myContent.edu {
    background: #45bcf3;
  }
</style>



// WEBPACK FOOTER //
// src/components/googleMaps.vue